export default __webpack_public_path__ + "static/media/swapIcon.11f136ea.svg";